import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-restore-archive-button',
  templateUrl: './restore-archive-button.component.html',
  styleUrls: ['./restore-archive-button.component.scss'],
  imports: [TranslateModule, MatMenuItem, MatIconButton, MatTooltip, MatIcon],
})
export class RestoreArchiveButtonComponent {
  @Input() isMenu = false;

  constructor() {}
}
